import {
  ACTIVITY_FILTER_CHANGE,
  ADD_COMMENT_REPLY_REQUEST_ASYNC,
  BLOCKED_ATTACKS_ACTIVITY_LOG_REQUEST_ASYNC,
  CAMPAIGNS_ACTIVITY_LOG_REQUEST_ASYNC,
  COMMENTS_ACTIVITY_LOG_REQUEST_ASYNC,
  DISMISS_INSIGHTS_REQUEST_ASYNC,
  INCIDENTS_ACTIVITY_LOG_REQUEST_ASYNC,
  INSIGHTS_REQUEST_ASYNC,
} from './constants'

const getIncidentsActivityLog = () => ({
  type: INCIDENTS_ACTIVITY_LOG_REQUEST_ASYNC.INITIATE,
})
export const getIncidentsActivityLogSuccess = (data) => ({
  type: INCIDENTS_ACTIVITY_LOG_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
const getIncidentsActivityLogCancel = () => ({
  type: INCIDENTS_ACTIVITY_LOG_REQUEST_ASYNC.CANCEL,
})
export const getIncidentsActivityLogError = (error) => ({
  type: INCIDENTS_ACTIVITY_LOG_REQUEST_ASYNC.ERROR,
  error,
})

const getCampaignsActivityLog = () => ({
  type: CAMPAIGNS_ACTIVITY_LOG_REQUEST_ASYNC.INITIATE,
})
export const getCampaignsActivityLogSuccess = (data) => ({
  type: CAMPAIGNS_ACTIVITY_LOG_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
const getCampaignsActivityLogCancel = () => ({
  type: CAMPAIGNS_ACTIVITY_LOG_REQUEST_ASYNC.CANCEL,
})
export const getCampaignsActivityLogError = (error) => ({
  type: CAMPAIGNS_ACTIVITY_LOG_REQUEST_ASYNC.ERROR,
  error,
})

const getCommentsActivityLog = () => ({
  type: COMMENTS_ACTIVITY_LOG_REQUEST_ASYNC.INITIATE,
})
export const getCommentsActivityLogSuccess = (data) => ({
  type: COMMENTS_ACTIVITY_LOG_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
const getCommentsActivityLogCancel = () => ({
  type: COMMENTS_ACTIVITY_LOG_REQUEST_ASYNC.CANCEL,
})
export const getCommentsActivityLogError = (error) => ({
  type: COMMENTS_ACTIVITY_LOG_REQUEST_ASYNC.ERROR,
  error,
})

const getBlockedAttacksActivityLog = ({ background = false } = {}) => ({
  type: BLOCKED_ATTACKS_ACTIVITY_LOG_REQUEST_ASYNC.INITIATE,
  payload: { background },
})
export const getBlockedAttacksActivityLogSuccess = (data) => ({
  type: BLOCKED_ATTACKS_ACTIVITY_LOG_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
const getBlockedAttacksActivityLogCancel = () => ({
  type: BLOCKED_ATTACKS_ACTIVITY_LOG_REQUEST_ASYNC.CANCEL,
})
export const getBlockedAttacksActivityLogError = (error) => ({
  type: BLOCKED_ATTACKS_ACTIVITY_LOG_REQUEST_ASYNC.ERROR,
  error,
})

const getInsights = () => ({ type: INSIGHTS_REQUEST_ASYNC.INITIATE })
export const getInsightsSuccess = (data) => ({
  type: INSIGHTS_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
const getInsightsCancel = () => ({ type: INSIGHTS_REQUEST_ASYNC.CANCEL })
export const getInsightsError = (error) => ({
  type: INSIGHTS_REQUEST_ASYNC.ERROR,
  error,
})

const dismissInsight = (data) => ({
  type: DISMISS_INSIGHTS_REQUEST_ASYNC.INITIATE,
  payload: { data },
})
export const dismissInsightSuccess = () => ({
  type: DISMISS_INSIGHTS_REQUEST_ASYNC.SUCCESS,
})
export const dismissInsightError = (error) => ({
  type: DISMISS_INSIGHTS_REQUEST_ASYNC.ERROR,
  error,
})

const handleFilterChange = (value) => ({
  type: ACTIVITY_FILTER_CHANGE,
  payload: { value },
})

const addCommentReply = (commentId, text, reportId, reportTypePrefix) => ({
  type: ADD_COMMENT_REPLY_REQUEST_ASYNC.INITIATE,
  payload: { commentId, text, reportId, reportTypePrefix },
})
export const addCommentReplySuccess = () => ({
  type: ADD_COMMENT_REPLY_REQUEST_ASYNC.SUCCESS,
})
export const addCommentReplyError = (error) => ({
  type: ADD_COMMENT_REPLY_REQUEST_ASYNC.ERROR,
  error,
})

export default {
  getIncidentsActivityLog,
  getIncidentsActivityLogCancel,
  getCampaignsActivityLog,
  getCampaignsActivityLogCancel,
  getCommentsActivityLog,
  getCommentsActivityLogCancel,
  getBlockedAttacksActivityLog,
  getBlockedAttacksActivityLogCancel,
  getInsights,
  getInsightsCancel,
  dismissInsight,
  handleFilterChange,
  addCommentReply,
}
